import ready from './ready'

export default async function registerPeriodicSync () {
  const status = await navigator.permissions.query({
    name: 'periodic-background-sync',
  })
  if (status.state !== 'granted') {
    // Periodic background sync cannot be used. This is the case when app is not installed.
    console.log("Cannot enable periodic background sync. Is the app installed?")
    return
  }

  // Periodic background sync can be used.
  ready()
    .then(async registration => {
      if (registration) {
        if ('periodicSync' in registration) {
          const tags = await registration.periodicSync.getTags();
          if (tags.includes('sync-db')) {
            console.log("Periodic background sync already enabled.")
          } else {
            await registration.periodicSync.register("sync-db", {
              minInterval: 12 * 60 * 60 * 1000, // Apparently every 12 hours is the most frequent that periodic sync will ever update
            })
            console.log("Enabled periodic background sync.")
          }
        }
      }
    })
}
